import { CompanyStatus, IdentityStatus } from 'api/v2/users/verifications';
import { Nullable } from 'types/global.types';
import { PeppolIntegrationScheme } from 'types/integrations';
import { AvailableCountries, VATTypeEnum } from 'types/users.types';

type Data = {
  companyStatus: Nullable<CompanyStatus>;
  identityStatus: Nullable<IdentityStatus>;
};

export enum VerificationActionId {
  Start = 'start',
  InReview = 'inReview',
  Resubmission = 'resubmission',
  Rejected = 'rejected',
}

export const getVerificationActionId = (data: Data) => {
  const { companyStatus, identityStatus } = data;

  if (!companyStatus && !identityStatus) return VerificationActionId.Start;

  const isIdentityPending =
    identityStatus === IdentityStatus.not_started ||
    identityStatus === IdentityStatus.started ||
    identityStatus === IdentityStatus.expired ||
    identityStatus === IdentityStatus.abandoned;

  const isCompanyPending = companyStatus === CompanyStatus.not_started;

  if (isIdentityPending || isCompanyPending) {
    return VerificationActionId.Start;
  }

  const isIdentityInReview = identityStatus === IdentityStatus.submitted;

  if (isIdentityInReview) {
    return VerificationActionId.InReview;
  }

  const isIdentityResubmissionRequested =
    identityStatus === IdentityStatus.resubmission_requested;

  if (isIdentityResubmissionRequested) {
    return VerificationActionId.Resubmission;
  }

  const isIdentityRejected = identityStatus === IdentityStatus.declined;

  const isCompanyRejected = companyStatus === CompanyStatus.declined;

  if (isIdentityRejected || isCompanyRejected) {
    return VerificationActionId.Rejected;
  }
};

type FullPeppolIdentifier = {
  scheme: PeppolIntegrationScheme;
  identifier: string;
};

export const getFullPeppolIdentifier = (data: FullPeppolIdentifier) => {
  const { scheme, identifier } = data;

  if (scheme === PeppolIntegrationScheme.BE_VAT) {
    return `9925:${identifier}, 0208:${identifier.replace('BE', '')}`;
  }

  if (scheme === PeppolIntegrationScheme.DE_VAT) {
    return `9930:${identifier}`;
  }

  // IBAN - Germany
  return `9918:${identifier}`;
};
